export default {
  download: 'Herunterladen',
}